<h2 mat-dialog-title>Download Weseth Client</h2>
<mat-dialog-content class="mat-typography">

        <div class=eula-popup>

                <p class=MsoNormal>End-User License Agreement (&quot;Agreement&quot;)</p>

                <p class=MsoNormal>Last updated: January 18, 2023</p>

                <p class=MsoNormal>Please read this End-User License Agreement
                        carefully before clicking the &quot;I Agree&quot; button, downloading or using
                        WESETH.</p>

                <h2 class=MsoTitle>Interpretation and Definitions</h2>
                <hr>

                <h3>Interpretation</h3>

                <p class=MsoNormal>The words of which the initial letter is
                        capitalized have meanings defined under the following conditions. The following
                        definitions shall have the same meaning regardless of whether they appear in
                        singular or in plural.</p>

                <h3>Definitions</h3>

                <p class=MsoNormalFor>the purposes of this End-User License Agreement:</p>

                <p class=MsoListParagraphCxSpFirst><b>Agreement</b> means this
                        End-User
                        License Agreement that forms the entire
                        agreement between You and the Company regarding the use of the Application.</p>

                <p class=MsoListParagraphCxSpMiddle><b>Application</b> means
                        the
                        software program provided by the Company downloaded by
                        You to a Device, named WESETH</p>

                <p class=MsoListParagraphCxSpMiddle><b>Company</b> (referred to
                        as
                        either &quot;the Company&quot;, &quot;We&quot;,
                        &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Drivesec srl,
                        Corso Re Umberto I 10, 10121 Torino.</p>

                <p class=MsoListParagraphCxSpMiddle><b>Content</b> refers to
                        content
                        such as text, images, or other information that
                        can be posted, uploaded, linked to or otherwise made available by You,
                        regardless of the form of that content.</p>

                <p class=MsoListParagraphCxSpMiddle><b>Country</b> refers to:
                        Italy</p>

                <p class=MsoListParagraphCxSpMiddle><b>Device</b> means any
                        device that
                        can access the Application such as a
                        computer, a cellphone or a digital tablet.</p>

                <p class=MsoListParagraphCxSpMiddle><b>Third-Party Services</b>
                        means
                        any services or content (including data, information,
                        applications and other products services) provided by a third-party that may be
                        displayed, included or made available by the Application.</p>

                <p class=MsoListParagraphCxSpLast><b>You</b> means the
                        individual
                        accessing or using the Application or the company,
                        or other legal entity on behalf of which such individual is accessing or using
                        the Application, as applicable.</p>

                <h2 class=MsoTitle>Acknowledgment</h2>
                <hr>

                <p class=MsoNormal>By clicking the &quot;I Agree&quot; button,
                        downloading or using the Application, You are agreeing to be bound by the terms
                        and conditions of this Agreement. If You do not agree to the terms of this
                        Agreement, do not click on the &quot;I Agree&quot; button, do not download or
                        do not use the Application.</p>

                <p class=MsoNormal>This Agreement is a legal document between
                        You and the Company and it governs your use of the Application made available
                        to You by the Company.</p>

                <p class=MsoNormal>The Application is licensed, not sold, to
                        You by the Company for use strictly in accordance with the terms of this
                        Agreement.</p>

                <h2 class=MsoTitle>License</h2>
                <hr>
                <h3>Scope of License</h3>

                <p class=MsoNormal>The Company grants You a revocable,
                        non-exclusive, non-transferable, limited license to download, install and use
                        the Application strictly in accordance with the terms of this Agreement.</p>

                <p class=MsoNormal>The license that is granted to You by the
                        Company is solely for your personal, non-commercial purposes strictly in
                        accordance with the terms of this Agreement.</p>

                <h3>License Restrictions</h3>

                <p class=MsoNormal>You agree not to, and You will not permit
                        others to:</p>

                <p class=MsoListParagraphCxSpFirst>License, sell, rent, lease,
                        assign, distribute, transmit, host, outsource, disclose or otherwise
                        commercially exploit the Application or make the Application available to any
                        third party.</p>

                <p class=MsoListParagraphCxSpLast>Remove, alter or obscure any
                        proprietary notice (including any notice of copyright or trademark) of the
                        Company or its affiliates, partners, suppliers or the licensors of the
                        Application.</p>

                <h2 class=MsoTitle>Intellectual Property</h2>
                <hr>

                <p class=MsoNormal>The Application, including without
                        limitation all copyrights, patents, trademarks, trade secrets and other
                        intellectual property rights are, and shall remain, the sole and exclusive
                        property of the Company.</p>

                <p class=MsoNormal>The Company shall not be obligated to indemnify
                        or defend You with respect to any third party claim arising out of or relating
                        to the Application. To the extent the Company is required to provide
                        indemnification by applicable law, the Company shall be solely responsible for
                        the investigation, defense, settlement and discharge of any claim that the
                        Application or your use of it infringes any third party intellectual property
                        rights.</p>

                <h2 class=MsoTitle>Modifications to the Application</h2>
                <hr>

                <p class=MsoNormal>The Company reserves the right to modify,
                        suspend or discontinue, temporarily or permanently, the Application or any
                        service to which it connects, with or without notice and without liability to
                        You.</p>

                <h3>Updates to the Application</h3>

                <p class=MsoNormal>The Company may from time to time provide
                        enhancements or improvements to the features/functionality of the Application,
                        which may include patches, bug fixes, updates, upgrades and other
                        modifications.</p>

                <p class=MsoNormal>Updates may modify or delete certain
                        features and/or functionalities of the Application. You agree that the Company
                        has no obligation to (i) provide any Updates, or (ii) continue to provide or
                        enable any particular features and/or functionalities of the Application to
                        You.</p>

                <p class=MsoNormal>You further agree that all updates or any
                        other modifications will be (i) deemed to constitute an integral part of the
                        Application, and (ii) subject to the terms and conditions of this Agreement.</p>

                <h3>Maintenance and Support</h3>

                <p class=MsoNormal>The Company does not provide any
                        maintenance or support for the download and use of the Application. To the
                        extent that any maintenance or support is required by applicable law, the Company
                        shall be obligated to furnish any such maintenance or support.</p>

                <h2 class=MsoTitle>Third-Party Services</h2>
                <hr>

                <p class=MsoNormal>The Application may display, include or
                        make available third-party content (including data, information, applications
                        and other products services) or provide links to third-party websites or
                        services.</p>

                <p class=MsoNormal>You acknowledge and agree that the Company
                        shall not be responsible for any Third-party Services, including their
                        accuracy, completeness, timeliness, validity, copyright compliance, legality,
                        decency, quality or any other aspect thereof. The Company does not assume and
                        shall not have any liability or responsibility to You or any other person or
                        entity for any Third-party Services.</p>

                <p class=MsoNormal>You must comply with applicable Third
                        parties' Terms of agreement when using the Application. Third-party Services
                        and links thereto are provided solely as a convenience to You and You access
                        and use them entirely at your own risk and subject to such third parties' Terms
                        and conditions.</p>

                <h2 class=MsoTitle>Term and Termination</h2>
                <hr>

                <p class=MsoNormal>This Agreement shall remain in effect until
                        terminated by You or the Company. The Company may, in its sole discretion, at
                        any time and for any or no reason, suspend or terminate this Agreement with or
                        without prior notice.</p>

                <p class=MsoNormal>This Agreement will terminate immediately,
                        without prior notice from the Company, in the event that you fail to comply
                        with any provision of this Agreement. You may also terminate this Agreement by
                        deleting the Application and all copies thereof from your Device or from your
                        computer.</p>

                <p class=MsoNormal>Upon termination of this Agreement, You
                        shall cease all use of the Application and delete all copies of the Application
                        from your Device.</p>

                <p class=MsoNormal>Termination of this Agreement will not
                        limit any of the Company's rights or remedies at law or in equity in case of
                        breach by You (during the term of this Agreement) of any of your obligations
                        under the present Agreement.</p>

                <h2 class=MsoTitle>Indemnification</h2>
                <hr>

                <p class=MsoNormal>You agree to indemnify and hold the Company
                        and its parents, subsidiaries, affiliates, officers, employees, agents,
                        partners and licensors (if any) harmless from any claim or demand, including
                        reasonable attorneys' fees, due to or arising out of your: (a) use of the
                        Application; (b) violation of this Agreement or any law or regulation; or (c)
                        violation of any right of a third party.</p>

                <h2 class=MsoTitle>No Warranties</h2>
                <hr>

                <p class=MsoNormal>The Application is provided to You &quot;AS
                        IS&quot; and &quot;AS AVAILABLE&quot; and with all faults and defects without
                        warranty of any kind. To the maximum extent permitted under applicable law, the
                        Company, on its own behalf and on behalf of its affiliates and its and their
                        respective licensors and service providers, expressly disclaims all warranties,
                        whether express, implied, statutory or otherwise, with respect to the
                        Application, including all implied warranties of merchantability, fitness for a
                        particular purpose, title and non-infringement, and warranties that may arise
                        out of course of dealing, course of performance, usage or trade practice.
                        Without limitation to the foregoing, the Company provides no warranty or
                        undertaking, and makes no representation of any kind that the Application will
                        meet your requirements, achieve any intended results, be compatible or work
                        with any other software, applications, systems or services, operate without
                        interruption, meet any performance or reliability standards or be error free or
                        that any errors or defects can or will be corrected.</p>

                <p class=MsoNormal>Without limiting the foregoing, neither the
                        Company nor any of the company's provider makes any representation or warranty
                        of any kind, express or implied: (i) as to the operation or availability of the
                        Application, or the information, content, and materials or products included
                        thereon; (ii) that the Application will be uninterrupted or error-free; (iii)
                        as to the accuracy, reliability, or currency of any information or content
                        provided through the Application; or (iv) that the Application, its servers,
                        the content, or e-mails sent from or on behalf of the Company are free of
                        viruses, scripts, trojan horses, worms, malware, timebombs or other harmful
                        components.</p>

                <p class=MsoNormal>Some jurisdictions do not allow the
                        exclusion of certain types of warranties or limitations on applicable statutory
                        rights of a consumer, so some or all of the above exclusions and limitations
                        may not apply to You. But in such a case the exclusions and limitations set
                        forth in this section shall be applied to the greatest extent enforceable under
                        applicable law. To the extent any warranty exists under law that cannot be
                        disclaimed, the Company shall be solely responsible for such warranty.</p>


                <h2 class=MsoTitle>Limitation of Liability</h2>
                <hr>

                <p class=MsoNormal>Notwithstanding any damages that You might
                        incur, the entire liability of the Company and any of its suppliers under any
                        provision of this Agreement and your exclusive remedy for all of the foregoing
                        shall be limited to the amount actually paid by You for the Application or
                        through the Application or 100 USD if You haven't purchased anything through
                        the Application.</p>

                <p class=MsoNormal>To the maximum extent permitted by
                        applicable law, in no event shall the Company or its suppliers be liable for
                        any special, incidental, indirect, or consequential damages whatsoever
                        (including, but not limited to, damages for loss of profits, loss of data or
                        other information, for business interruption, for personal injury, loss of
                        privacy arising out of or in any way related to the use of or inability to use
                        the Application, third-party software and/or third-party hardware used with the
                        Application, or otherwise in connection with any provision of this Agreement),
                        even if the Company or any supplier has been advised of the possibility of such
                        damages and even if the remedy fails of its essential purpose.</p>

                <p class=MsoNormal>Some states/jurisdictions do not allow the
                        exclusion or limitation of incidental or consequential damages, so the above
                        limitation or exclusion may not apply to You.</p>

                <h2 class=MsoTitle>Severability and Waiver</h2>
                <hr>


                <h3>Severability</h3>

                <p class=MsoNormal>If any provision of this Agreement is held
                        to be unenforceable or invalid, such provision will be changed and interpreted
                        to accomplish the objectives of such provision to the greatest extent possible
                        under applicable law and the remaining provisions will continue in full force
                        and effect.</p>

                <h3>Waiver</h3>

                <p class=MsoNormal>Except as provided herein, the failure to
                        exercise a right or to require performance of an obligation under this
                        Agreement shall not effect a party's ability to exercise such right or require
                        such performance at any time thereafter nor shall the waiver of a breach
                        constitute a waiver of any subsequent breach.</p>


                <h2 class=MsoTitle>Product Claims</h2>
                <hr>

                <p class=MsoNormal>The Company does not make any warranties
                        concerning the Application.</p>


                <h2 class=MsoTitle>United States Legal Compliance</h2>
                <hr>

                <p class=MsoNormal>You represent and warrant that (i) You are
                        not located in a country that is subject to the United States government
                        embargo, or that has been designated by the United States government as a
                        &quot;terrorist supporting&quot; country, and (ii) You are not listed on any
                        United States government list of prohibited or restricted parties.</p>


                <h2 class=MsoTitle>Changes to this Agreement</h2>
                <hr>

                <p class=MsoNormal>The Company reserves the right, at its sole
                        discretion, to modify or replace this Agreement at any time. If a revision is
                        material we will provide at least 30 days' notice prior to any new terms taking
                        effect. What constitutes a material change will be determined at the sole
                        discretion of the Company.</p>

                <p class=MsoNormal>By continuing to access or use the
                        Application after any revisions become effective, You agree to be bound by the
                        revised terms. If You do not agree to the new terms, You are no longer
                        authorized to use the Application.</p>


                <h2 class=MsoTitle>Governing Law</h2>
                <hr>

                <p class=MsoNormal>The laws of the Country, excluding its
                        conflicts of law rules, shall govern this Agreement and your use of the
                        Application. Your use of the Application may also be subject to other local,
                        state, national, or international laws.</p>


                <h2 class=MsoTitle>Entire Agreement</h2>
                <hr>

                <p class=MsoNormal>The Agreement constitutes the entire
                        agreement between You and the Company regarding your use of the Application and
                        supersedes all prior and contemporaneous written or oral agreements between You
                        and the Company.</p>

                <p class=MsoNormal>You may be subject to additional terms and
                        conditions that apply when You use or purchase other Company's services, which
                        the Company will provide to You at the time of such use or purchase.</p>

                <h2 class=MsoTitle>Contact Us</h2>
                <hr>

                <p class=MsoNormal>If you have any questions about this
                        Agreement, You can contact Us:</p>

                <p class=MsoListBullet>
                        By email: info@drivesec.com</p>

        </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Decline</button>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Accept</button>
</mat-dialog-actions>